import { React, useState, useEffect, useRef } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import QRScannerView from "./QRScannerView";
import QRCodeResultView from "./QRCodeResultView";
import { BASE_URL } from "../Config";

function QRCodeReaderMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "QR Code Scanner, Reader Free",
  };

  //scan result
  const [scanResult, setScanResult] = useState({ error: null, result: [] });

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/qr_scanner", title: "Scan QR Codes" },
    data2: { link: "/qr_scanner", title: "QR Scanner Free" },
    data3: { link: "/qr_scanner", title: "Barcode Scanner Free" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageContext.Provider
      value={{
        setScanResult,
        scanResult,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Scan QR codes & Barcodes online instantly. Read URLs, text, and more with our fast, secure, and easy-to-use QR code scanner tool."
      ></meta>
      <meta
        name="keywords"
        content="qr code scanner, scan qr code online, qr reader, online qr code scanner, qr code reader tool, read qr code, scan qr code, qr code scanning tool, qr code reader online, qr code scanner app, qr code scanner free, qr code reader for website, qr code reader online free, qr code scanning online, qr code reader fast, barcode scanner, scan barcodes,"
      ></meta>

      {/* page content */}
      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={false} />
        {/* Qr scanner */}
        <QRScannerView />
        {/* Result View */}
        <QRCodeResultView />
        {/* Mid Section */}
        <MiscPageMidSection description="Our QR Code Scanner website is a fast, secure, and easy-to-use solution designed to scan QR codes instantly using your device camera or uploaded images. This online QR code scanner supports all QR code types, including website URLs, Wi-Fi credentials, contact details, text, email, SMS, payment links, and social media profiles, making it ideal for personal and business use. With a clean and responsive interface, users can scan QR code online on mobile, tablet, or desktop without installing any app. The website ensures complete privacy, as scanned data is processed securely and never stored on our servers. Whether you need a free QR code scanner for quick access to information, digital payments, menus, or event check-ins, this QR scanner online delivers accurate and real-time results. Optimized for speed and compatibility, our QR code reader works smoothly across all modern browsers and operating systems, providing a reliable and convenient way to scan QR codes online anytime, anywhere." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Select",
            step2: "Offline",
            step3: "Scan",
            step4: "View",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="QR Code Scanner"
          why_use={[
            {
              title: "Instant Access to Digital Information",
              description:
                "Our QR code scanner allows users to instantly open websites, documents, payment links, and contact details by scanning a code.",
            },
            {
              title: "Fast and Contactless Payments",
              description:
                "Using a QR code scanner enables quick and secure contactless payments, making transactions simple and convenient.",
            },
            {
              title: "Quick Product Identification",
              description:
                "This barcode scanner helps identify products instantly by scanning barcodes for pricing, inventory, and product details.",
            },
            {
              title: "Save Time and Increase Efficiency",
              description:
                "Our QR code scanner and barcode scanner reduce manual data entry, helping users complete tasks faster.",
            },
            {
              title: "Essential for Business and Retail Use",
              description:
                "Businesses rely on barcode scanner tools for inventory management, billing, and stock tracking.",
            },
            {
              title: "Offline-Friendly Code Scanning",
              description:
                "Many QR code scanner tools work offline after scanning, allowing users to access saved information later.",
            },
            {
              title: "Support Marketing and Promotions",
              description:
                "Companies use QR code scanner technology to connect customers to offers, websites, and promotional campaigns.",
            },
            {
              title: "Improve Accuracy and Reduce Errors",
              description:
                "Using a barcode scanner minimizes human errors compared to manual entry of product or item codes.",
            },
            {
              title: "Useful for Education and Events",
              description:
                "Schools and event organizers use QR code scanner and barcode scanner tools for attendance, tickets, and resource access.",
            },
          ]}
        />
        {/* Download on Appsroe */}
        <MiscDownloadOnAppStore
          id={`https://apps.apple.com/app/id${1189800081}`}
        />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default QRCodeReaderMain;
